<template>

  <div class="supplement">

    <div class="supplement__content content">
      <div class="content__image">
        <el-image fit="contain"
                  :src="product.image_mini"
                  style="height: 80px; width: 80px;"
                  :alt="product.title"/>
      </div>
      <div class="content__description description">
        <h3 class="description__title">{{ product.title }}</h3>
        <span v-if="product.duration || product.country" class="description__information">
          {{ product.duration }} • {{ product.country }}
         </span>
        <span class="description__information">
            {{ product.price }}  {{ product.bonus }}
         </span>
      </div>
    </div>

    <el-button v-if="add" @click="editSelected" class="supplement__btn" :type="product.selected ? 'primary' : ''">
      <i class="el-icon-plus"></i>
    </el-button>
    <el-button v-else @click="deleteItem" class="supplement__btn" type="danger" icon="el-icon-delete">

    </el-button>

  </div>
</template>

<script>
export default {
  name: "ProcedureItem",
  props: {
    product: {
      type: Object,
      required: true,
      default: () => ({})
    },
    add: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: this.product.selected,
    }
  },
  methods: {
    editSelected() {
      this.product.selected = !this.product.selected
      this.$emit('save', this.product.id)
    },
    deleteItem () {
      this.$emit('remove', this.product.id)
    }
  }
}
</script>

<style scoped lang="scss">
.supplement {
  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;

  margin: 10px 8px;
  padding: 10px;

  &_selected {
    background: #CCF9EF;
    box-shadow: 0 2px 4px rgba(55, 71, 79, 0.16), 0 4px 8px rgba(55, 71, 79, 0.08);
  }

  &__btn {
    width: 44px;
    height: 44px;
    //margin-top: 20px;
    font-size: 13px !important;
    margin-bottom: 8px;
  }

  &__content {
    flex: 1;
  }

}

.content {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: start;
  gap: 12px;
  border-bottom: 1px solid #EAEAEA;
  padding-bottom: 8px;

  &__image {

    width: 80px !important;
    max-height: 80px;
  }

}

.description {

  &__title {
    margin-top: 0;
    margin-bottom: 3px;

    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
  }

  &__information {
    font-size: 15px;
    line-height: 140%;
    color: #909399;

  }
}

.edit-icon {
  color: #8E8E93;
  cursor: pointer;
  font-size: 13px;

  &:hover {
    opacity: 0.5
  }
}
</style>
